import axios from '../../../services/axios'

import * as actionTypes from '../actionTypes';
import {setMessage} from "../message";

export const loadMarkSheetRequests = () => {
    return {
        type: actionTypes.LOAD_MARK_SHEET_REQUESTS
    }
}

export const setMarkSheetRequests = (markSheetRequests) => {
    return {
        type: actionTypes.SET_MARK_SHEET_REQUESTS,
        markSheetRequests: markSheetRequests
    }
}

export const getMarkSheetRequests = () => {
    return (dispatch) => {
        dispatch(loadMarkSheetRequests())
        axios.get( `/api/v1/mark-sheet`)
            .then( response => {
                dispatch( setMarkSheetRequests(response.data))
            } )
            .catch( error => {
                dispatch(setMessage({type: 'warning', text: "Не удалось подключиться к серверу."}))
            } );
    }
}

////////////////////////////////////////////////////////////////

export const loadMarkSheetTypes = () => {
    return {
        type: actionTypes.LOAD_MARK_SHEET_TYPES
    }
}

export const setMarkSheetTypes = (markSheetTypes) => {
    return {
        type: actionTypes.SET_MARK_SHEET_TYPES,
        markSheetTypes: markSheetTypes
    }
}

export const getMarkSheetTypes = () => {
    return (dispatch) => {
        dispatch(loadMarkSheetTypes())
        axios.get( `/api/v1/mark-sheet/types`  )
            .then( response => {
                dispatch( setMarkSheetTypes(response.data))
            } )
            .catch( error => {
                dispatch(setMessage({type: 'warning', text: "Не удалось подключиться к серверу."}))
            } );
    }
}

////////////////////////////////////////////////////////////////

export const setMarkSheetSubjects = (markSheetSubjects) => {
    return {
        type: actionTypes.SET_MARK_SHEET_SUBJECTS,
        markSheetSubjects: markSheetSubjects
    }
}

export const loadMarkSheetSubjects = () => {
    return {
        type: actionTypes.LOAD_MARK_SHEET_SUBJECTS
    }
}

export const getMarkSheetSubjects = () => {
    return (dispatch) => {
        dispatch(loadMarkSheetSubjects())
        axios.get( `/api/v1/mark-sheet/subjects`)
            .then( response => {
                dispatch( setMarkSheetSubjects(response.data))
            } )
            .catch( error => {
                dispatch(setMessage({type: 'warning', text: "Не удалось подключиться к серверу."}))
            } );
    }
}

////////////////////////////////////////////////////////////////

export const sendMarkSheetRequest = () => {
    return {
        type: actionTypes.SEND_MARK_SHEET_REQUEST
    }
}

export const receiveSendMarkSheetRequestResult = (result) => {
    return {
        type: actionTypes.RECEIVE_SEND_MARK_SHEET_REQUEST_RESULT,
        newMarkSheetRequest: result
    }
}

export const postMarkSheetRequest = (dto) => {
    return (dispatch) => {
        dispatch(sendMarkSheetRequest())
        axios.post( `/api/v1/mark-sheet`, dto)
            .then( response => {
                dispatch(setMessage({type: 'success', text: "Ведомостичка успешно заказана."}))
                dispatch( receiveSendMarkSheetRequestResult(response.data));
            } )
            .catch( error => {
                dispatch(setMessage({type: 'error', text: "Не удалось заказать ведомостичку."}))
            } );
    }
}

////////////////////////////////////////////////////////////////

export const updateMarkSheetRequest = (markSheetRequest) => {
    return {
        type: actionTypes.UPDATE_MARK_SHEET_REQUEST,
        markSheetRequest: markSheetRequest
    }
}

export const closeMarkSheetRequestById = (id) => {
    return (dispatch) => {
        axios.get( `/api/v1/mark-sheet/close?id=${id}`)
            .then( response => {
                dispatch(setMessage({type: 'success', text: "Ведомостичка успешно отменена."}))
                dispatch(updateMarkSheetRequest(response.data))
            } )
            .catch( error => {
                dispatch(setMessage({type: 'warning', text: "Не удалось отменить ведомостичку."}))
            } );
    }
}